// Bump TERMS_VERSION whenever the Terms & Conditions or Privacy Policy
// content materially changes — the version recorded at signup (see
// auth-controller.js) must trace back to what the user actually saw.
export const TERMS_VERSION = 'v2';
export const TERMS_LAST_UPDATED = '24 July 2026';
